// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Sale from "../../modules/Sale/Sale.res.js";
import * as View from "../../primitives/View.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as CountBadge from "../../resources/feedback-indicators/CountBadge.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Pervasives from "@rescript/runtime/lib/es6/Pervasives.js";
import * as SalesTable from "../../modules/Sale/SalesTable.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as SalesRoutes from "./SalesRoutes.res.js";
import * as DeviceSelect from "../../modules/Device/DeviceSelect.res.js";
import * as ResourceList from "../../core/ResourceList.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as PaymentMethod from "../../modules/PaymentMethod.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CustomerSelect from "../../modules/Customer/CustomerSelect.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as CategoryTablist from "../../resources/navigation/CategoryTablist.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ResourceListPage from "../../core/ResourceListPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ListNavigationState from "../../core/ListNavigationState.res.js";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as SalesListPageExportModal from "./SalesListPageExportModal.res.js";
let make = React.memo(props => {
  let notification = props.notification;
  if (notification === undefined) {
    return null;
  }
  let tmp;
  tmp = notification.TAG === "Ok" ? {
    TAG: "Success",
    _0: notification._0
  } : {
    TAG: "Danger",
    _0: notification._0
  };
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(Banner.make, {
      textStatus: tmp,
      onRequestClose: props.onRequestClose
    }),
    spaceX: "large",
    spaceTop: "medium"
  });
});
let SalesListNotificationBanner = {
  make: make
};
let jsonCodec = JsonCodec.object1(param => Sale.toString(param.saleType), saleType => ({
  TAG: "Ok",
  _0: {
    saleType: Sale.fromStringExn(saleType)
  }
}), JsonCodec.field("saleType", JsonCodec.string));
let SalesListExtraParams = {
  jsonCodec: jsonCodec
};
function encodeValues(values) {
  if (values.length !== 0) {
    return values;
  }
}
let dateRangeCodec = JsonCodec.object2(param => [param[0].getTime(), param[1].getTime()], param => ({
  TAG: "Ok",
  _0: [new Date(param[0]), new Date(param[1])]
}), JsonCodec.field("start", JsonCodec.float), JsonCodec.field("end", JsonCodec.float));
let customerCodec = JsonCodec.object3(param => [Stdlib_Option.getOr(Primitive_option.fromNullable(param.id), "null"), param.name, param.business], param => {
  let id = param[0];
  return {
    TAG: "Ok",
    _0: {
      id: id === "null" ? null : id,
      name: param[1],
      business: Stdlib_Option.getWithDefault(param[2], false)
    }
  };
}, JsonCodec.field("id", JsonCodec.string), JsonCodec.field("name", JsonCodec.string), JsonCodec.optional(JsonCodec.field("business", JsonCodec.bool)));
let deviceCodec = JsonCodec.object2(param => [param.id, param.label], param => ({
  TAG: "Ok",
  _0: {
    id: param[0],
    label: param[1]
  }
}), JsonCodec.field("id", JsonCodec.string), JsonCodec.field("label", JsonCodec.string));
function jsonCodec$1(shops) {
  return JsonCodec.object9(param => [Stdlib_Option.map(param.shop, shop => shop.id), encodeValues(param.statuses.map(Sale.Status.toString)), param.delivered, param.billed, param.date, param.dueDate, param.customer, encodeValues(param.devices), encodeValues(param.paymentMethods.map(PaymentMethod.toRawString))], param => {
    let shopId = param[0];
    return {
      TAG: "Ok",
      _0: {
        shop: shops.find(shop => shop.id === shopId),
        statuses: Stdlib_Array.filterMap(Stdlib_Option.getOr(param[1], []), status => ["Draft", "Started", "Overdue", "Completed", "Canceled"].find(current => Sale.Status.toString(current) === status)),
        delivered: param[2],
        billed: param[3],
        date: param[4],
        dueDate: param[5],
        customer: param[6],
        devices: Stdlib_Option.getOr(param[7], []),
        paymentMethods: Stdlib_Array.filterMap(Stdlib_Option.getOr(param[8], []), PaymentMethod.fromRawString)
      }
    };
  }, JsonCodec.optional(JsonCodec.field("shopId", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("statuses", JsonCodec.array(JsonCodec.string))), JsonCodec.optional(JsonCodec.field("delivered", JsonCodec.bool)), JsonCodec.optional(JsonCodec.field("billed", JsonCodec.bool)), JsonCodec.optional(JsonCodec.field("date", dateRangeCodec)), JsonCodec.optional(JsonCodec.field("dueDate", dateRangeCodec)), JsonCodec.optional(JsonCodec.field("customer", customerCodec)), JsonCodec.optional(JsonCodec.field("devices", JsonCodec.array(deviceCodec))), JsonCodec.optional(JsonCodec.field("paymentMethods", JsonCodec.array(JsonCodec.string))));
}
function statusesForSaleType(saleType) {
  switch (saleType) {
    case "Invoice":
      return ["Draft", "Started", "Overdue", "Completed", "Canceled"];
    case "SalesReceipt":
      return ["Completed", "Canceled"];
    case "CreditNote":
    case "RefundReceipt":
      return [];
    case "DeliveryNote":
      return ["Draft", "Completed"];
    case "Quote":
      return ["Started", "Completed"];
  }
}
function keepCompatibleFilters(filters, saleType) {
  let compatibleStatuses = statusesForSaleType(saleType);
  let tmp;
  tmp = saleType === "Invoice" ? filters.delivered : undefined;
  let tmp$1;
  switch (saleType) {
    case "DeliveryNote":
    case "Quote":
      tmp$1 = filters.billed;
      break;
    default:
      tmp$1 = undefined;
  }
  let tmp$2;
  tmp$2 = saleType === "Invoice" ? filters.dueDate : undefined;
  let tmp$3;
  switch (saleType) {
    case "Invoice":
    case "SalesReceipt":
    case "RefundReceipt":
      tmp$3 = filters.paymentMethods;
      break;
    default:
      tmp$3 = [];
  }
  return {
    shop: filters.shop,
    statuses: filters.statuses.filter(status => compatibleStatuses.includes(status)),
    delivered: tmp,
    billed: tmp$1,
    date: filters.date,
    dueDate: tmp$2,
    customer: filters.customer,
    devices: filters.devices,
    paymentMethods: tmp$3
  };
}
let SalesListFilters = {
  encodeValues: encodeValues,
  dateRangeCodec: dateRangeCodec,
  customerCodec: customerCodec,
  deviceCodec: deviceCodec,
  jsonCodec: jsonCodec$1,
  statusesForSaleType: statusesForSaleType,
  keepCompatibleFilters: keepCompatibleFilters
};
function queryFiltersFromFilters(filters) {
  return {
    shopId: Stdlib_Option.map(filters.shop, shop => shop.id),
    customerId: Stdlib_Option.map(filters.customer, customer => customer.id),
    deviceIds: filters.devices.map(device => device.id),
    paymentMethods: filters.paymentMethods,
    statuses: filters.statuses,
    delivered: filters.delivered,
    billed: filters.billed,
    date: filters.date,
    dueDate: filters.dueDate
  };
}
let tableLoadingInvoicesOperations = [SalesTable.SalesListInvoicesQuery.query];
let tableLoadingSalesReceiptsOperations = [SalesTable.SalesListSalesReceiptsQuery.query];
let tableLoadingRefundReceiptsOperations = [SalesTable.SalesListRefundReceiptsQuery.query];
let tableLoadingCreditNotesOperations = [SalesTable.SalesListCreditNotesQuery.query];
let tableLoadingDeliveryNotesOperations = [SalesTable.SalesListDeliveryNotesQuery.query];
let tableLoadingQuotesOperations = [SalesTable.SalesListQuotesQuery.query];
function tableLoadingOperations(saleType) {
  switch (saleType) {
    case "Invoice":
      return tableLoadingInvoicesOperations;
    case "SalesReceipt":
      return tableLoadingSalesReceiptsOperations;
    case "CreditNote":
      return tableLoadingCreditNotesOperations;
    case "RefundReceipt":
      return tableLoadingRefundReceiptsOperations;
    case "DeliveryNote":
      return tableLoadingDeliveryNotesOperations;
    case "Quote":
      return tableLoadingQuotesOperations;
  }
}
function invoicesQueryVariablesFilterBy(filters) {
  return SalesTable.invoicesQueryVariablesFilterBy(queryFiltersFromFilters(filters));
}
function salesReceiptsQueryVariablesFilterBy(filters) {
  return SalesTable.salesReceiptsQueryVariablesFilterBy(queryFiltersFromFilters(filters));
}
function creditNotesQueryVariablesFilterBy(filters) {
  return SalesTable.creditNotesQueryVariablesFilterBy(queryFiltersFromFilters(filters));
}
function refundReceiptsQueryVariablesFilterBy(filters) {
  return SalesTable.refundReceiptsQueryVariablesFilterBy(queryFiltersFromFilters(filters));
}
function deliveryNotesQueryVariablesFilterBy(filters) {
  return SalesTable.deliveryNotesQueryVariablesFilterBy(queryFiltersFromFilters(filters));
}
function quotesQueryVariablesFilterBy(filters) {
  return SalesTable.quotesQueryVariablesFilterBy(queryFiltersFromFilters(filters));
}
function invoicesQueryVariables(param) {
  return SalesTable.invoicesQueryVariables({
    connectionArguments: param.connectionArguments,
    searchQuery: param.searchQuery,
    filters: queryFiltersFromFilters(param.filters),
    sorting: param.sorting
  });
}
function salesReceiptsQueryVariables(param) {
  return SalesTable.salesReceiptsQueryVariables({
    connectionArguments: param.connectionArguments,
    searchQuery: param.searchQuery,
    filters: queryFiltersFromFilters(param.filters),
    sorting: param.sorting
  });
}
function creditNotesQueryVariables(param) {
  return SalesTable.creditNotesQueryVariables({
    connectionArguments: param.connectionArguments,
    searchQuery: param.searchQuery,
    filters: queryFiltersFromFilters(param.filters),
    sorting: param.sorting
  });
}
function refundReceiptsQueryVariables(param) {
  return SalesTable.refundReceiptsQueryVariables({
    connectionArguments: param.connectionArguments,
    searchQuery: param.searchQuery,
    filters: queryFiltersFromFilters(param.filters),
    sorting: param.sorting
  });
}
function deliveryNotesQueryVariables(param) {
  return SalesTable.deliveryNotesQueryVariables({
    connectionArguments: param.connectionArguments,
    searchQuery: param.searchQuery,
    filters: queryFiltersFromFilters(param.filters),
    sorting: param.sorting
  });
}
function quotesQueryVariables(param) {
  return SalesTable.quotesQueryVariables({
    connectionArguments: param.connectionArguments,
    searchQuery: param.searchQuery,
    filters: queryFiltersFromFilters(param.filters),
    sorting: param.sorting
  });
}
let make$1 = React.memo(props => {
  let onChange = props.onChange;
  let value = props.value;
  let __multipleSelection = props.multipleSelection;
  let saleType = props.saleType;
  let multipleSelection = __multipleSelection !== undefined ? __multipleSelection : false;
  let defaultItem_1 = I18n.t("All");
  let defaultItem_4 = true;
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: undefined,
    exclusive: defaultItem_4
  };
  let items = props.statuses.map(value => ({
    TAG: "Option",
    key: Sale.Status.toLabel(undefined, saleType, value),
    label: Sale.Status.toLabel(undefined, saleType, value),
    value: value
  }));
  return JsxRuntime.jsx(Select.make, {
    label: I18n.t("Status"),
    preset: "filter",
    size: "compact",
    highlighted: value.length !== 0,
    shouldSelectTogether: (value, other) => {
      if (value !== "Draft") {
        return other !== "Draft";
      } else {
        return false;
      }
    },
    renderValue: param => {
      let selectedItems = param.selectedItems;
      let exit = 0;
      let len = selectedItems.length;
      if (len !== 1) {
        exit = len !== 0 ? 1 : 2;
      } else {
        let match = selectedItems[0];
        if (match.TAG === "Option") {
          let status = match.value;
          if (status !== undefined) {
            let match$1 = Sale.Status.Badge.toStyleSet(status, saleType);
            return JsxRuntime.jsx(Inline.make, {
              children: JsxRuntime.jsx(Badge.make, {
                children: Sale.Status.toLabel(undefined, saleType, status),
                iconSvg: match$1.iconSvg,
                size: "normal",
                borderColor: match$1.borderColor,
                backgroundColor: match$1.bgColor,
                foregroundColor: match$1.textColor
              })
            });
          }
          exit = 2;
        } else {
          exit = 1;
        }
      }
      switch (exit) {
        case 1:
          return JsxRuntime.jsx(CountBadge.make, {
            children: selectedItems.length.toString(),
            size: "small",
            tone: "brand"
          });
        case 2:
          return JsxRuntime.jsx("span", {
            children: I18n.t("All")
          });
      }
    },
    renderItem: param => {
      let item = param.item;
      if (item.TAG !== "Option") {
        return null;
      }
      let status = item.value;
      if (status === undefined) {
        return JsxRuntime.jsx("span", {
          children: I18n.t("All")
        });
      }
      let match = Sale.Status.Badge.toStyleSet(status, saleType);
      return JsxRuntime.jsx(Inline.make, {
        children: JsxRuntime.jsx(Badge.make, {
          children: Sale.Status.toLabel(undefined, saleType, status),
          iconSvg: match.iconSvg,
          size: "medium",
          borderColor: match.borderColor,
          backgroundColor: match.bgColor,
          foregroundColor: match.textColor
        })
      });
    },
    sections: [{
      items: [defaultItem]
    }, {
      items: items,
      title: I18n.t("Statuses")
    }],
    value: multipleSelection ? {
      TAG: "Multiple",
      _0: value.length !== 0 ? value.map(status => status) : [undefined]
    } : {
      TAG: "Single",
      _0: value[0]
    },
    onChange: change => {
      if (change.TAG === "Single") {
        return onChange(Stdlib_Option.mapOr(change._0, [], status => [status]));
      } else {
        return onChange(Stdlib_Array.filterMap(change._0, value => value));
      }
    }
  });
});
let SalesListFilterStatusSelect = {
  make: make$1
};
let make$2 = React.memo(props => {
  let onChange = props.onChange;
  let value = props.value;
  let notOkLabel = props.notOkLabel;
  let okLabel = props.okLabel;
  let label = props.label;
  let statuses = [false, true];
  let defaultItem_1 = I18n.t("All");
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: undefined
  };
  let items = statuses.map(status => ({
    TAG: "Option",
    key: Pervasives.string_of_bool(status),
    label: status ? okLabel : notOkLabel,
    value: status
  }));
  return JsxRuntime.jsx(Select.make, {
    label: label,
    preset: "filter",
    size: "compact",
    highlighted: Stdlib_Option.isSome(value),
    sections: [{
      items: [defaultItem]
    }, {
      items: items,
      title: label
    }],
    value: {
      TAG: "Single",
      _0: value
    },
    onChange: change => {
      if (change.TAG === "Single") {
        return onChange(change._0);
      }
    }
  });
});
let SalesListFilterSecondaryStatusSelect = {
  make: make$2
};
let make$3 = React.memo(props => {
  let onChange = props.onChange;
  let value = props.value;
  let defaultItem_1 = I18n.t("All");
  let defaultItem_4 = true;
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: undefined,
    exclusive: defaultItem_4
  };
  let items = PaymentMethod.values.map(paymentMethod => ({
    TAG: "Option",
    key: PaymentMethod.toRawString(paymentMethod),
    label: PaymentMethod.toLabel(paymentMethod),
    value: paymentMethod
  }));
  return JsxRuntime.jsx(Select.make, {
    label: I18n.t("Payment method"),
    preset: "filter",
    size: "compact",
    highlighted: value.length !== 0,
    renderValue: param => {
      let selectedItems = param.selectedItems;
      let exit = 0;
      let len = selectedItems.length;
      if (len !== 1) {
        exit = len !== 0 ? 1 : 2;
      } else {
        let match = selectedItems[0];
        if (match.TAG === "Option") {
          let paymentMethod = match.value;
          if (paymentMethod !== undefined) {
            return JsxRuntime.jsx(Inline.make, {
              children: JsxRuntime.jsx(PaymentMethod.Badge.make, {
                value: paymentMethod,
                bordered: true
              })
            });
          }
          exit = 2;
        } else {
          exit = 1;
        }
      }
      switch (exit) {
        case 1:
          return JsxRuntime.jsx(CountBadge.make, {
            children: selectedItems.length.toString(),
            size: "small",
            tone: "brand"
          });
        case 2:
          return JsxRuntime.jsx("span", {
            children: I18n.t("All")
          });
      }
    },
    renderItem: param => {
      let item = param.item;
      if (item.TAG !== "Option") {
        return null;
      }
      let paymentMethod = item.value;
      if (paymentMethod !== undefined) {
        return JsxRuntime.jsx(Inline.make, {
          children: JsxRuntime.jsx(PaymentMethod.Badge.make, {
            value: paymentMethod,
            bordered: true
          })
        });
      } else {
        return JsxRuntime.jsx("span", {
          children: I18n.t("All")
        });
      }
    },
    sections: [{
      items: [defaultItem]
    }, {
      items: items,
      title: I18n.t("Payment methods")
    }],
    value: {
      TAG: "Multiple",
      _0: value.length !== 0 ? value.map(paymentMethod => paymentMethod) : [undefined]
    },
    onChange: change => {
      if (change.TAG === "Single") {
        return onChange(Stdlib_Option.mapOr(change._0, [], paymentMethod => [paymentMethod]));
      } else {
        return onChange(Stdlib_Array.filterMap(change._0, value => value));
      }
    }
  });
});
let SalesListFilterPaymentMethodSelect = {
  make: make$3
};
function SalesListPage$ViewPage(props) {
  let salesTableData = props.salesTableData;
  let dispatch = props.dispatch;
  let state = props.state;
  let initialState = props.initialState;
  let shops = Auth.useShops();
  let authScope = Auth.useScope();
  let organisationAccount;
  organisationAccount = authScope.TAG === "Organisation";
  let match = Navigation.useGoBack();
  let openedFromCustomer = React.useRef(Stdlib_Option.isSome(state.filters.customer)).current;
  let onRequestGoBack = match[0] && openedFromCustomer ? match[1] : undefined;
  let match$1 = React.useState(() => {});
  let setNotification = match$1[1];
  let match$2 = React.useState(() => false);
  let setExportModalOpened = match$2[1];
  let saleType = Stdlib_Option.mapOr(state.extra, SalesTable.initialSaleTypeValue, extra => extra.saleType);
  let tableLoadingOperations$1 = tableLoadingOperations(saleType);
  let compatibleFilters = keepCompatibleFilters(state.filters, saleType);
  let shopFilter = organisationAccount ? JsxRuntime.jsx(Auth.SelectShopFilter.make, {
    variation: "secondary",
    value: state.filters.shop,
    hideLabel: true,
    truncateItemLabel: true,
    onChange: shop => dispatch({
      TAG: "FiltersUpdated",
      _0: param => {
        let init = initialState.filters;
        return {
          shop: shop,
          statuses: init.statuses,
          delivered: init.delivered,
          billed: init.billed,
          date: init.date,
          dueDate: init.dueDate,
          customer: init.customer,
          devices: init.devices,
          paymentMethods: init.paymentMethods
        };
      }
    })
  }) : null;
  let activeFiltersCount = [Stdlib_Option.isSome(compatibleFilters.customer), compatibleFilters.paymentMethods.length !== 0, compatibleFilters.statuses.length !== 0, Stdlib_Option.isSome(compatibleFilters.date), Stdlib_Option.isSome(compatibleFilters.dueDate), Stdlib_Option.isSome(compatibleFilters.delivered), Stdlib_Option.isSome(compatibleFilters.billed), compatibleFilters.devices.length !== 0].filter(active => active).length;
  let handleFilterReset = activeFiltersCount > 0 ? () => dispatch({
    TAG: "FiltersUpdated",
    _0: param => {
      let init = initialState.filters;
      return {
        shop: state.filters.shop,
        statuses: init.statuses,
        delivered: init.delivered,
        billed: init.billed,
        date: init.date,
        dueDate: init.dueDate,
        customer: init.customer,
        devices: init.devices,
        paymentMethods: init.paymentMethods
      };
    }
  }) : undefined;
  let onTableSortChange = sortDescriptor => {
    let sort = SalesTable.SalesTableSorting.fromSortDescriptor(sortDescriptor);
    if (sort.TAG === "Ok") {
      return dispatch({
        TAG: "SortingUpdated",
        _0: sort._0
      });
    }
  };
  let notSpecifiedCustomerLabel;
  switch (saleType) {
    case "SalesReceipt":
    case "RefundReceipt":
      notSpecifiedCustomerLabel = I18n.t("Walk-in customers");
      break;
    default:
      notSpecifiedCustomerLabel = I18n.t("Unregistered customers");
  }
  let filters;
  let exit = 0;
  switch (saleType) {
    case "Invoice":
      filters = [JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.date,
        label: I18n.t("Issue"),
        size: "compact",
        highlighted: Stdlib_Option.isSome(state.filters.date),
        placeholder: I18n.template(I18n.t("All{{feminine}}"), undefined, undefined),
        hidePresets: true,
        onChange: date => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        }),
        triggerLabelDisplay: "showDateRange"
      }), JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.dueDate,
        label: I18n.t("Due"),
        size: "compact",
        highlighted: Stdlib_Option.isSome(state.filters.dueDate),
        placeholder: I18n.template(I18n.t("All{{feminine}}"), undefined, undefined),
        hidePresets: true,
        onChange: dueDate => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        }),
        triggerLabelDisplay: "showDateRange"
      }), JsxRuntime.jsx(CanarySeparator.make, {
        size: "medium",
        spacing: "xs"
      }), JsxRuntime.jsx(make$1, {
        saleType: saleType,
        statuses: statusesForSaleType(saleType),
        multipleSelection: true,
        value: compatibleFilters.statuses,
        onChange: statuses => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        })
      }), JsxRuntime.jsx(make$2, {
        label: I18n.t("Delivery"),
        okLabel: I18n.t("Delivered"),
        notOkLabel: I18n.t("Not delivered"),
        value: state.filters.delivered,
        onChange: delivered => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        })
      }), JsxRuntime.jsx(CustomerSelect.make, {
        size: "compact",
        label: I18n.t("Registered customer"),
        preset: "filter",
        highlighted: Stdlib_Option.isSome(state.filters.customer),
        showDefaultItem: true,
        showNotSpecifiedItem: true,
        notSpecifiedLabel: notSpecifiedCustomerLabel,
        shopId: Stdlib_Option.map(state.filters.shop, shop => shop.id),
        value: state.filters.customer,
        onChange: customer => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        })
      }), JsxRuntime.jsx(make$3, {
        value: state.filters.paymentMethods,
        onChange: paymentMethods => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: paymentMethods
          })
        })
      }), JsxRuntime.jsx(DeviceSelect.make, {
        size: "compact",
        shopId: Stdlib_Option.map(state.filters.shop, shop => shop.id),
        value: state.filters.devices,
        onChange: devices => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: devices,
            paymentMethods: prev.paymentMethods
          })
        })
      })];
      break;
    case "SalesReceipt":
      filters = [JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.date,
        label: I18n.t("Issue"),
        size: "compact",
        highlighted: Stdlib_Option.isSome(state.filters.date),
        placeholder: I18n.template(I18n.t("All{{feminine}}"), undefined, undefined),
        hidePresets: true,
        onChange: date => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        }),
        triggerLabelDisplay: "showDateRange"
      }), JsxRuntime.jsx(CanarySeparator.make, {
        size: "medium",
        spacing: "xs"
      }), JsxRuntime.jsx(make$1, {
        saleType: saleType,
        statuses: statusesForSaleType(saleType),
        value: compatibleFilters.statuses,
        onChange: statuses => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        })
      }), JsxRuntime.jsx(CustomerSelect.make, {
        size: "compact",
        label: I18n.t("Registered customer"),
        preset: "filter",
        highlighted: Stdlib_Option.isSome(state.filters.customer),
        showDefaultItem: true,
        showNotSpecifiedItem: true,
        notSpecifiedLabel: notSpecifiedCustomerLabel,
        includeArchivedItems: true,
        shopId: Stdlib_Option.map(state.filters.shop, shop => shop.id),
        value: state.filters.customer,
        onChange: customer => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        })
      }), JsxRuntime.jsx(make$3, {
        value: state.filters.paymentMethods,
        onChange: paymentMethods => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: paymentMethods
          })
        })
      }), JsxRuntime.jsx(DeviceSelect.make, {
        size: "compact",
        shopId: Stdlib_Option.map(state.filters.shop, shop => shop.id),
        value: state.filters.devices,
        onChange: devices => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: devices,
            paymentMethods: prev.paymentMethods
          })
        })
      })];
      break;
    case "CreditNote":
    case "RefundReceipt":
      exit = 1;
      break;
    case "DeliveryNote":
      filters = [JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.date,
        label: I18n.t("Delivery date"),
        size: "compact",
        highlighted: Stdlib_Option.isSome(state.filters.date),
        placeholder: I18n.template(I18n.t("All{{feminine}}"), undefined, undefined),
        hidePresets: true,
        onChange: date => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        }),
        triggerLabelDisplay: "showDateRange"
      }), JsxRuntime.jsx(CanarySeparator.make, {
        size: "medium",
        spacing: "xs"
      }), JsxRuntime.jsx(make$1, {
        saleType: saleType,
        statuses: statusesForSaleType(saleType),
        value: compatibleFilters.statuses,
        onChange: statuses => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        })
      }), JsxRuntime.jsx(make$2, {
        label: I18n.t("Billing"),
        okLabel: I18n.t("Billed"),
        notOkLabel: I18n.t("Not billed"),
        value: state.filters.billed,
        onChange: billed => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        })
      }), JsxRuntime.jsx(CustomerSelect.make, {
        size: "compact",
        label: I18n.t("Registered customer"),
        preset: "filter",
        highlighted: Stdlib_Option.isSome(state.filters.customer),
        showDefaultItem: true,
        showNotSpecifiedItem: true,
        notSpecifiedLabel: notSpecifiedCustomerLabel,
        shopId: Stdlib_Option.map(state.filters.shop, shop => shop.id),
        value: state.filters.customer,
        onChange: customer => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        })
      }), JsxRuntime.jsx(DeviceSelect.make, {
        size: "compact",
        shopId: Stdlib_Option.map(state.filters.shop, shop => shop.id),
        value: state.filters.devices,
        onChange: devices => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: devices,
            paymentMethods: prev.paymentMethods
          })
        })
      })];
      break;
    case "Quote":
      filters = [JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.date,
        label: I18n.t("Issue"),
        size: "compact",
        highlighted: Stdlib_Option.isSome(state.filters.date),
        placeholder: I18n.template(I18n.t("All{{feminine}}"), undefined, undefined),
        hidePresets: true,
        onChange: date => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        }),
        triggerLabelDisplay: "showDateRange"
      }), JsxRuntime.jsx(CanarySeparator.make, {
        size: "medium",
        spacing: "xs"
      }), JsxRuntime.jsx(make$1, {
        saleType: saleType,
        statuses: statusesForSaleType(saleType),
        value: compatibleFilters.statuses,
        onChange: statuses => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        })
      }), JsxRuntime.jsx(make$2, {
        label: I18n.t("Billing"),
        okLabel: I18n.t("Billed"),
        notOkLabel: I18n.t("Not billed"),
        value: state.filters.billed,
        onChange: billed => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        })
      }), JsxRuntime.jsx(CustomerSelect.make, {
        size: "compact",
        label: I18n.t("Registered customer"),
        preset: "filter",
        highlighted: Stdlib_Option.isSome(state.filters.customer),
        showDefaultItem: true,
        showNotSpecifiedItem: true,
        notSpecifiedLabel: notSpecifiedCustomerLabel,
        shopId: Stdlib_Option.map(state.filters.shop, shop => shop.id),
        value: state.filters.customer,
        onChange: customer => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: customer,
            devices: prev.devices,
            paymentMethods: prev.paymentMethods
          })
        })
      }), JsxRuntime.jsx(DeviceSelect.make, {
        size: "compact",
        shopId: Stdlib_Option.map(state.filters.shop, shop => shop.id),
        value: state.filters.devices,
        onChange: devices => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            statuses: prev.statuses,
            delivered: prev.delivered,
            billed: prev.billed,
            date: prev.date,
            dueDate: prev.dueDate,
            customer: prev.customer,
            devices: devices,
            paymentMethods: prev.paymentMethods
          })
        })
      })];
      break;
  }
  if (exit === 1) {
    let tmp;
    tmp = saleType === "RefundReceipt" ? [JsxRuntime.jsx(make$3, {
      value: state.filters.paymentMethods,
      onChange: paymentMethods => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => ({
          shop: prev.shop,
          statuses: prev.statuses,
          delivered: prev.delivered,
          billed: prev.billed,
          date: prev.date,
          dueDate: prev.dueDate,
          customer: prev.customer,
          devices: prev.devices,
          paymentMethods: paymentMethods
        })
      })
    })] : [];
    filters = [JsxRuntime.jsx(SelectDateRangeFilter.make, {
      value: state.filters.date,
      label: I18n.t("Issue"),
      size: "compact",
      highlighted: Stdlib_Option.isSome(state.filters.date),
      placeholder: I18n.template(I18n.t("All{{feminine}}"), undefined, undefined),
      hidePresets: true,
      onChange: date => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => ({
          shop: prev.shop,
          statuses: prev.statuses,
          delivered: prev.delivered,
          billed: prev.billed,
          date: date,
          dueDate: prev.dueDate,
          customer: prev.customer,
          devices: prev.devices,
          paymentMethods: prev.paymentMethods
        })
      }),
      triggerLabelDisplay: "showDateRange"
    }), JsxRuntime.jsx(CanarySeparator.make, {
      size: "medium",
      spacing: "xs"
    }), JsxRuntime.jsx(CustomerSelect.make, {
      size: "compact",
      label: I18n.t("Registered customer"),
      preset: "filter",
      highlighted: Stdlib_Option.isSome(state.filters.customer),
      showDefaultItem: true,
      showNotSpecifiedItem: true,
      notSpecifiedLabel: notSpecifiedCustomerLabel,
      includeArchivedItems: true,
      shopId: Stdlib_Option.map(state.filters.shop, shop => shop.id),
      value: state.filters.customer,
      onChange: customer => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => ({
          shop: prev.shop,
          statuses: prev.statuses,
          delivered: prev.delivered,
          billed: prev.billed,
          date: prev.date,
          dueDate: prev.dueDate,
          customer: customer,
          devices: prev.devices,
          paymentMethods: prev.paymentMethods
        })
      })
    })].concat(tmp).concat([JsxRuntime.jsx(DeviceSelect.make, {
      size: "compact",
      shopId: Stdlib_Option.map(state.filters.shop, shop => shop.id),
      value: state.filters.devices,
      onChange: devices => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => ({
          shop: prev.shop,
          statuses: prev.statuses,
          delivered: prev.delivered,
          billed: prev.billed,
          date: prev.date,
          dueDate: prev.dueDate,
          customer: prev.customer,
          devices: devices,
          paymentMethods: prev.paymentMethods
        })
      })
    })]);
  }
  let searchBar = JsxRuntime.jsx(ResourceListPage.ResourceListSearchBar.make, {
    placeholder: I18n.t("Search") + "...",
    value: state.searchQuery,
    onChange: searchQuery => dispatch({
      TAG: "Searched",
      _0: searchQuery
    })
  });
  let actions = JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(Button.make, {
      label: I18n.t("Export"),
      icon: "export",
      onPress: () => setExportModalOpened(param => true)
    }), JsxRuntime.jsx(SalesListPageExportModal.make, {
      opened: match$2[0],
      onRequestOpenChange: opened => setExportModalOpened(param => opened),
      onRequestNotification: result => setNotification(param => result)
    })]
  });
  let newrecord = {
    ...{
      style: {
        borderBottomColor: "#E7E7EE",
        borderBottomStyle: "solid",
        borderBottomWidth: "1px"
      }
    }
  };
  let tableHeader = JsxRuntime.jsxs(View.make, (newrecord.children = [JsxRuntime.jsx(make, {
    notification: match$1[0],
    onRequestClose: () => setNotification(param => {})
  }), JsxRuntime.jsx(CategoryTablist.make, {
    items: SalesTable.saleTypeValues.map(value => ({
      key: Sale.toString(value),
      label: Sale.toLabel(true, value)
    })),
    value: Sale.toString(saleType),
    onChange: key => {
      let saleType = Sale.fromStringExn(key);
      let newrecord = {
        ...state
      };
      newrecord.connectionArguments = initialState.connectionArguments;
      newrecord.extra = {
        saleType: saleType
      };
      let init = state.filters;
      newrecord.filters = {
        shop: init.shop,
        statuses: [],
        delivered: init.delivered,
        billed: init.billed,
        date: init.date,
        dueDate: init.dueDate,
        customer: init.customer,
        devices: init.devices,
        paymentMethods: init.paymentMethods
      };
      dispatch({
        TAG: "Reset",
        _0: (newrecord.previousPage = -1, newrecord.currentPage = 1, newrecord)
      });
    }
  })], newrecord));
  let match$3 = salesTableData.rows;
  let listNavigationRouterOptions;
  let exit$1 = 0;
  let rows;
  if (typeof match$3 !== "object") {
    listNavigationRouterOptions = undefined;
  } else if (match$3.TAG === "Reloading") {
    let rows$1 = match$3._0;
    if (rows$1.TAG === "Ok") {
      rows = rows$1._0;
      exit$1 = 1;
    } else {
      listNavigationRouterOptions = undefined;
    }
  } else {
    let rows$2 = match$3._0;
    if (rows$2.TAG === "Ok") {
      rows = rows$2._0;
      exit$1 = 1;
    } else {
      listNavigationRouterOptions = undefined;
    }
  }
  if (exit$1 === 1) {
    let items = rows.map(param => SalesRoutes.showRoute(param.saleType, param.id));
    listNavigationRouterOptions = {
      state: ListNavigationState.encode({
        items: items
      })
    };
  }
  let tableColumns = SalesTable.SalesTableColumns.use(saleType, shops, true, undefined, Stdlib_Option.isSome(state.filters.shop), salesTableData.electronicInvoicingFeatureState, listNavigationRouterOptions);
  let paginationCurrentPage = state.currentPage;
  let paginationTotalCount = AsyncData.getWithDefault(salesTableData.totalCount, 0);
  let paginationTotalPages = ResourceList.totalPages(paginationTotalCount, ResourceList.defaultEdgesPerPage);
  let paginationLoading = salesTableData.loading;
  let paginationLastDirection = state.currentPage > state.previousPage ? "Forward" : "Backward";
  let onRequestPaginate = React.useCallback(action => {
    let match = salesTableData.pageInfo;
    if (match === undefined) {
      return;
    }
    let totalPages = ResourceList.totalPages(paginationTotalCount, ResourceList.defaultEdgesPerPage);
    let nextPage = ResourceList.nextPage(state, action, totalPages);
    let cursors_0 = match.startCursor;
    let cursors_1 = match.endCursor;
    let cursors = [cursors_0, cursors_1];
    if (nextPage !== undefined) {
      return dispatch({
        TAG: "Navigated",
        nextPage: nextPage,
        totalCount: paginationTotalCount,
        cursors: cursors
      });
    }
  }, [state.currentPage, paginationTotalCount, salesTableData.pageInfo]);
  let tableLoadingInteraction = ResourceList.useLoadingInteraction(state, tableLoadingOperations$1);
  return JsxRuntime.jsx(ResourceListPage.make, {
    title: I18n.t("sales_list_page.title"),
    shopFilter: shopFilter,
    filters: filters,
    activeFiltersCount: activeFiltersCount,
    actions: actions,
    searchBar: searchBar,
    tableHeader: tableHeader,
    tableData: salesTableData.rows,
    tableColumns: tableColumns,
    tableKeyExtractor: SalesTable.SalesListTableRow.keyExtractor,
    tableEmptyState: JsxRuntime.jsx(Placeholder.make, {
      status: "NoDataAvailable"
    }),
    paginationCurrentPage: paginationCurrentPage,
    paginationTotalCount: paginationTotalCount,
    paginationTotalPages: paginationTotalPages,
    paginationLoading: paginationLoading,
    paginationLastDirection: paginationLastDirection,
    tableSortDescriptor: SalesTable.SalesTableSorting.toSortDescriptor(state.sorting),
    tableLoadingOperations: tableLoadingOperations$1,
    tableLoadingInteraction: tableLoadingInteraction,
    onTableSortChange: onTableSortChange,
    onRequestPaginate: onRequestPaginate,
    onRequestGoBack: onRequestGoBack,
    onRequestResetFilters: handleFilterReset
  });
}
let ViewPage = {
  make: SalesListPage$ViewPage
};
function SalesListPage(props) {
  let __useQuotesQueryAsyncResult = props.useQuotesQueryAsyncResult;
  let __useDeliveryNotesQueryAsyncResult = props.useDeliveryNotesQueryAsyncResult;
  let __useCreditNotesQueryAsyncResult = props.useCreditNotesQueryAsyncResult;
  let __useRefundReceiptsQueryAsyncResult = props.useRefundReceiptsQueryAsyncResult;
  let __useSalesReceiptsQueryAsyncResult = props.useSalesReceiptsQueryAsyncResult;
  let __useInvoicesQueryAsyncResult = props.useInvoicesQueryAsyncResult;
  let useInvoicesQueryAsyncResult = __useInvoicesQueryAsyncResult !== undefined ? __useInvoicesQueryAsyncResult : SalesTable.SalesTableData.useInvoicesQueryAsyncResultFn;
  let useSalesReceiptsQueryAsyncResult = __useSalesReceiptsQueryAsyncResult !== undefined ? __useSalesReceiptsQueryAsyncResult : SalesTable.SalesTableData.useSalesReceiptsQueryAsyncResultFn;
  let useRefundReceiptsQueryAsyncResult = __useRefundReceiptsQueryAsyncResult !== undefined ? __useRefundReceiptsQueryAsyncResult : SalesTable.SalesTableData.useRefundReceiptsQueryAsyncResultFn;
  let useCreditNotesQueryAsyncResult = __useCreditNotesQueryAsyncResult !== undefined ? __useCreditNotesQueryAsyncResult : SalesTable.SalesTableData.useCreditNotesQueryAsyncResultFn;
  let useDeliveryNotesQueryAsyncResult = __useDeliveryNotesQueryAsyncResult !== undefined ? __useDeliveryNotesQueryAsyncResult : SalesTable.SalesTableData.useDeliveryNotesQueryAsyncResultFn;
  let useQuotesQueryAsyncResult = __useQuotesQueryAsyncResult !== undefined ? __useQuotesQueryAsyncResult : SalesTable.SalesTableData.useQuotesQueryAsyncResultFn;
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let extra = {
    saleType: SalesTable.initialSaleTypeValue
  };
  let filters_statuses = [];
  let filters_devices = [];
  let filters_paymentMethods = [];
  let filters = {
    shop: activeShop,
    statuses: filters_statuses,
    delivered: undefined,
    billed: undefined,
    date: undefined,
    dueDate: undefined,
    customer: undefined,
    devices: filters_devices,
    paymentMethods: filters_paymentMethods
  };
  let initialState = ResourceList.initialState(50, filters, {
    TAG: "Date",
    _0: "descending"
  }, extra, undefined);
  let sortingJsonCodec = SalesTable.SalesTableSorting.jsonCodec;
  let filtersJsonCodec = jsonCodec$1(shops);
  let match = ResourceList.use(initialState, filtersJsonCodec, sortingJsonCodec, Primitive_option.some(jsonCodec), undefined);
  let state = match[0];
  let saleType = Stdlib_Option.mapOr(state.extra, SalesTable.initialSaleTypeValue, extra => extra.saleType);
  let salesTableData = SalesTable.SalesTableData.use(saleType, state.connectionArguments, queryFiltersFromFilters(keepCompatibleFilters(state.filters, saleType)), state.sorting, state.searchQuery, {
    useInvoicesQueryAsyncResult: useInvoicesQueryAsyncResult,
    useSalesReceiptsQueryAsyncResult: useSalesReceiptsQueryAsyncResult,
    useRefundReceiptsQueryAsyncResult: useRefundReceiptsQueryAsyncResult,
    useCreditNotesQueryAsyncResult: useCreditNotesQueryAsyncResult,
    useDeliveryNotesQueryAsyncResult: useDeliveryNotesQueryAsyncResult,
    useQuotesQueryAsyncResult: useQuotesQueryAsyncResult
  });
  return JsxRuntime.jsx(SalesListPage$ViewPage, {
    initialState: initialState,
    state: state,
    dispatch: match[1],
    salesTableData: salesTableData
  });
}
let initialSaleTypeValue = SalesTable.initialSaleTypeValue;
let SalesListInvoicesQuery;
let SalesListSalesReceiptsQuery;
let SalesListCreditNotesQuery;
let SalesListRefundReceiptsQuery;
let SalesListDeliveryNotesQuery;
let SalesListQuotesQuery;
let SalesListTableRow;
let SalesListSorting;
let isDatetimeBackdated = SalesTable.isDatetimeBackdated;
let groupPaymentMethodsByOccurrence = SalesTable.groupPaymentMethodsByOccurrence;
let invoicesTableRowsFromQueryResult = SalesTable.invoicesTableRowsFromQueryResult;
let salesReceiptsTableRowsFromQueryResult = SalesTable.salesReceiptsTableRowsFromQueryResult;
let creditNotesTableRowsFromQueryResult = SalesTable.creditNotesTableRowsFromQueryResult;
let refundReceiptsTableRowsFromQueryResult = SalesTable.refundReceiptsTableRowsFromQueryResult;
let deliveryNotesTableRowsFromQueryResult = SalesTable.deliveryNotesTableRowsFromQueryResult;
let quotesTableRowsFromQueryResult = SalesTable.quotesTableRowsFromQueryResult;
let invoicesQueryVariablesOrderBy = SalesTable.invoicesQueryVariablesOrderBy;
let salesReceiptsQueryVariablesOrderBy = SalesTable.salesReceiptsQueryVariablesOrderBy;
let creditNotesQueryVariablesOrderBy = SalesTable.creditNotesQueryVariablesOrderBy;
let refundReceiptsQueryVariablesOrderBy = SalesTable.refundReceiptsQueryVariablesOrderBy;
let deliveryNotesQueryVariablesOrderBy = SalesTable.deliveryNotesQueryVariablesOrderBy;
let quotesQueryVariablesOrderBy = SalesTable.quotesQueryVariablesOrderBy;
let make$4 = SalesListPage;
export { initialSaleTypeValue, SalesListNotificationBanner, SalesListExtraParams, SalesListFilters, queryFiltersFromFilters, SalesListInvoicesQuery, SalesListSalesReceiptsQuery, SalesListCreditNotesQuery, SalesListRefundReceiptsQuery, SalesListDeliveryNotesQuery, SalesListQuotesQuery, SalesListTableRow, tableLoadingInvoicesOperations, tableLoadingSalesReceiptsOperations, tableLoadingRefundReceiptsOperations, tableLoadingCreditNotesOperations, tableLoadingDeliveryNotesOperations, tableLoadingQuotesOperations, tableLoadingOperations, SalesListSorting, isDatetimeBackdated, groupPaymentMethodsByOccurrence, invoicesTableRowsFromQueryResult, salesReceiptsTableRowsFromQueryResult, creditNotesTableRowsFromQueryResult, refundReceiptsTableRowsFromQueryResult, deliveryNotesTableRowsFromQueryResult, quotesTableRowsFromQueryResult, invoicesQueryVariablesOrderBy, salesReceiptsQueryVariablesOrderBy, creditNotesQueryVariablesOrderBy, refundReceiptsQueryVariablesOrderBy, deliveryNotesQueryVariablesOrderBy, quotesQueryVariablesOrderBy, invoicesQueryVariablesFilterBy, salesReceiptsQueryVariablesFilterBy, creditNotesQueryVariablesFilterBy, refundReceiptsQueryVariablesFilterBy, deliveryNotesQueryVariablesFilterBy, quotesQueryVariablesFilterBy, invoicesQueryVariables, salesReceiptsQueryVariables, creditNotesQueryVariables, refundReceiptsQueryVariables, deliveryNotesQueryVariables, quotesQueryVariables, SalesListFilterStatusSelect, SalesListFilterSecondaryStatusSelect, SalesListFilterPaymentMethodSelect, ViewPage, make$4 as make };
/* make Not a pure module */